import { render, staticRenderFns } from "./FormInputStandardUserWaiterReceiveMessagesFunction.vue?vue&type=template&id=625efdba&scoped=true&lang=pug"
import script from "./FormInputStandardUserWaiterReceiveMessagesFunction.vue?vue&type=script&lang=ts"
export * from "./FormInputStandardUserWaiterReceiveMessagesFunction.vue?vue&type=script&lang=ts"
import style0 from "./FormInputStandardUserWaiterReceiveMessagesFunction.vue?vue&type=style&index=0&id=625efdba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625efdba",
  null
  
)

export default component.exports